<script setup lang="ts">
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";
import type { FieldChange } from "@/model/change";
import { isUnset } from "@/model/change";
import { useSessionStore } from "@/store/session";

defineProps<{ field: FieldChange<number> }>();
</script>

<template>
  <div class="change horizontal">
    <template v-if="!isUnset(field.old)">
      <span class="change-value">
        <SvgIcon name="general/iteration" width="20" height="20" />
        {{ useSessionStore().getIterationName(field.old) }}
      </span>
      <SvgIcon
        name="arrow/right"
        width="20"
        height="20"
        role="img"
        :aria-label="$t('label.cardDiff.changedTo')"
      />
    </template>
    <template v-if="!isUnset(field.new)">
      <span class="change-value">
        <SvgIcon name="general/iteration" width="20" height="20" />
        {{ useSessionStore().getIterationName(field.new) }}
      </span>
    </template>
  </div>
</template>
